import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import {
    AdditionalFees,
    LaneFees,
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/Order/OrderBilling.requests'

type Args = {
    orderNumber: string,
    selectedInvoice: OutgoingInvoice,
}

const useGetFeesInfo = ({
    selectedInvoice,
}: Args): {
    laneFees: LaneFees,
    additionalFees: AdditionalFees,
} => {
    const {
        data: laneFees,
    } = useRequest<LaneFees>({
        key: RequestKeys.getLaneFees,
        params: {
            outgoingInvoiceId: selectedInvoice?.id,
        },
        requestFunc: RequestFn.getEntity(requests.getLaneFees),
        enabled: Boolean(selectedInvoice),
    })

    const {
        data: additionalFees,
    } = useRequest<AdditionalFees>({
        key: RequestKeys.getAdditionalFees,
        params: {
            outgoingInvoiceId: selectedInvoice?.id,
        },
        requestFunc: RequestFn.getEntity(requests.getAdditionalFees),
        enabled: Boolean(selectedInvoice),
    })

    return {
        laneFees,
        additionalFees,
    }
}

export default useGetFeesInfo
